module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"phone":"Phone","new number":"New number","discard":"Discard","change":"Change"},"de":{"phone":"Telefon","new number":"Neue Nummer","discard":"Verwerfen","change":"Ändern"}}')
  delete Component.options._Ctor
}
